import React, { FC } from 'react'
import { MediaBlock } from 'react-placeholder/lib/placeholders';

export const DoctorsListPlaceholder: FC = () => {
  return (
    <tr className="doctorsList__row">
      <td className="doctorsList__item" colSpan={5}>
        <div className="doctorsListPlaceholder">
          <MediaBlock color='rgb(205, 205, 205)' rows={2} />
        </div>
      </td>
    </tr>
  )
};
